export default {"src":"/_next/static/media/gradient-circles.3abb90b4.svg","height":1856,"width":2842};